import { Component } from '@angular/core';

// Static mockup for the Retail epic: no API calls, nothing saves.

interface MockPurchase {
  date: string;
  invoice: string;
  item: string;
  variant: string;
  qty: number;
  unitPrice: string;
  discount: string | null;
  location: string;
  status: string;
  canReturn: boolean;
}

@Component({
  selector: 'app-purchases-sub-list',
  templateUrl: './purchases-sub-list.component.html',
})
export class PurchasesSubListComponent {
  public readonly purchases: MockPurchase[] = [
    {
      date: 'Sep 26, 2026', invoice: '48213', item: 'P&P Crew Sweatshirt', variant: 'Green / M', qty: 1,
      unitPrice: '$48.00', discount: null, location: 'Downtown', status: 'Complete', canReturn: true,
    },
    {
      date: 'Sep 12, 2026', invoice: '47901', item: 'BD White Gold 300g', variant: '', qty: 2,
      unitPrice: '$14.00', discount: 'Member 15%', location: 'Downtown', status: 'Complete', canReturn: true,
    },
    {
      date: 'Aug 30, 2026', invoice: '47512', item: 'Petzl Adjama harness', variant: 'M', qty: 1,
      unitPrice: '$79.95', discount: 'Member 15%', location: 'Northside', status: 'Returned (store credit)', canReturn: false,
    },
    {
      date: 'Aug 2, 2026', invoice: '47102', item: 'Clif Bar', variant: '', qty: 3,
      unitPrice: '$2.50', discount: null, location: 'Downtown', status: 'Complete', canReturn: true,
    },
  ];
}
